import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 4.75a2.626 2.626 0 0 1 2.625 2.625v4.375a2.626 2.626 0 0 1-5.25 0V7.375A2.626 2.626 0 0 1 12 4.75m-3.5 5.906v1.094a3.49 3.49 0 0 0 3.5 3.5c1.914 0 3.5-1.559 3.5-3.5v-1.094c0-.355.273-.656.656-.656.356 0 .657.3.657.656v1.094c0 2.46-1.832 4.457-4.157 4.785v.902h1.313c.355 0 .656.301.656.657 0 .383-.3.656-.656.656H10.03a.63.63 0 0 1-.656-.656c0-.356.273-.657.656-.657h1.313v-.902a4.814 4.814 0 0 1-4.156-4.785v-1.094c0-.355.273-.656.656-.656.355 0 .656.3.656.656"
    }, null, -1)
  ]))]))
}
export default { render: render }